module.exports = __webpack_public_path__ + "img/sb12.f92a1d96.png";